module.exports = __webpack_public_path__ + "img/01-2.25fdb0f0.png";